var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 23,
    viewBox: "0 0 41 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3409 23C5.41255 23 2.44838 21.2274 2.44838 17.6823V4.35959H7.38514V17.6823C7.38514 18.512 7.6805 19.0871 8.27123 19.4077C8.88305 19.7094 9.92736 19.8603 11.4042 19.8603C12.8599 19.8603 13.8725 19.7094 14.4422 19.4077C15.0329 19.0871 15.3283 18.512 15.3283 17.6823V4.35959H20.265V17.6823C20.265 21.2274 17.2903 23 11.3409 23Z",
    fill: "#05FF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6391 4.35959H32.867C34.8712 4.35959 36.4535 4.48216 37.6139 4.72731C38.7953 4.97245 39.6498 5.40617 40.1772 6.02846C40.7257 6.63189 41 7.48047 41 8.57419V12.0534C41 13.2602 40.7046 14.2031 40.1139 14.8819C39.5443 15.5608 38.6266 16.0417 37.3607 16.3245C36.116 16.6074 34.4282 16.7488 32.2974 16.7488H29.5758V22.7171H24.6391V4.35959ZM32.7088 13.7222C33.9957 13.7222 34.9029 13.5902 35.4303 13.3262C35.9578 13.0434 36.2215 12.5719 36.2215 11.9119V8.97019C36.2215 8.36676 35.9683 7.97076 35.462 7.78219C34.9767 7.59361 34.0379 7.49933 32.6455 7.49933H29.5758V13.7222H32.7088Z",
    fill: "#05FF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94467 0L0 4.41967H9.88934L4.94467 0Z",
    fill: "#05FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUp);
export default __webpack_public_path__ + "static/media/icon-up.2fefada0405f57ba050349e11bd1b5e3.svg";
export { ForwardRef as ReactComponent };